import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldsInterventionsTractorUsageReportComponent } from './fields-interventions-tractors-usage-report.component';
import {DxChartModule, DxPivotGridModule} from 'devextreme-angular';



@NgModule({
  declarations: [FieldsInterventionsTractorUsageReportComponent],
  imports: [
    CommonModule,
    DxPivotGridModule,
    DxChartModule
  ],
  exports: [FieldsInterventionsTractorUsageReportComponent]
})
export class FieldsInterventionsTractorUsageReportModule { }
